import React from 'react';
import { BrowserRouter, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import {
  BookOutlined,
  ImportOutlined,
} from '@ant-design/icons';
import CoursesPage from './pages/CoursesPage';
import CourseImportPage from './pages/CourseImportPage';
import CourseAnalyticsPage from './pages/CourseAnalyticsPage';
import CourseLearnersPage from './pages/CourseLearnersPage';
import BatchImportPage from './pages/BatchImportPage';

const { Header, Content, Footer } = Layout;

function AppMenu() {
  const location = useLocation();
  const selectedKey = '/' + location.pathname.split('/')[1];

  const items = [
    { key: '/courses', icon: <BookOutlined />, label: <Link to="/courses">Courses</Link> },
    { key: '/batch', icon: <ImportOutlined />, label: <Link to="/batch">Batch Import</Link> },
  ];

  return (
    <Menu
      theme="dark"
      mode="horizontal"
      selectedKeys={[selectedKey]}
      items={items}
    />
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout style={{ minHeight: '100vh' }}>
        <Header style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ color: '#fff', fontWeight: 'bold', fontSize: 18, marginRight: 40 }}>
            Logs-EDX
          </div>
          <AppMenu />
        </Header>
        <Content style={{ padding: '24px 48px' }}>
          <Routes>
            <Route path="/" element={<Navigate to="/courses" replace />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/courses/:courseKey/import" element={<CourseImportPage />} />
            <Route path="/courses/:courseKey/analytics" element={<CourseAnalyticsPage />} />
            <Route path="/courses/:courseKey/learners" element={<CourseLearnersPage />} />
            <Route path="/batch" element={<BatchImportPage />} />
          </Routes>
        </Content>
        <Footer style={{ textAlign: 'center' }}>
          Logs-EDX - Open edX Tracking Logs Analytics
        </Footer>
      </Layout>
    </BrowserRouter>
  );
}
